import React from "react";

import styled from "@mui/material/styles/styled";

import Stack, { Column, Row, StackProps } from "@rui/Stack";

export const Thumbnail = styled(Column)(({ theme }) => ({
  height: "97px",
  width: "172px",
  borderRadius: "4px",
  position: "relative",
  overflow: "hidden",
  objectFit: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  backgroundColor: theme.palette.shades.neutral[900],
  marginBottom: theme.spacing(0.5),
}));

export const StyledVideo = styled("video")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  zIndex: 0,
  backgroundColor: "black",
  "&:hover": {
    cursor: "pointer",
  },
});

export const VideoContainer = styled(Stack)({
  position: "relative",
  borderRadius: "4px",
  overflow: "hidden",
  height: "100%",
  width: "100%",
});

export const VideoControlsContainer = styled((props: StackProps) => (
  <Row variant="right" {...props} />
))(({ theme }) => ({
  position: "absolute",
  borderRadius: "8px",
  padding: "8px",
  bottom: 0,
  left: 0,
  right: 0,
  transition: "all 0.5s ease",
  zIndex: 1,
  width: "100%",

  "& .scrubber__markers": { display: "none" },
  "& .player-controls": { flex: 1 },
  "& .player-controls__controls": {
    marginTop: theme.spacing(0.25),
  },
}));

type VideoContainerProps = StackProps & {
  expanded: boolean;
};

export const VideoOuterContainer = styled(
  ({ expanded: _expanded, ...props }: VideoContainerProps) => (
    <Stack {...props} />
  )
)(({ expanded, theme }) => ({
  position: "unset",
  height: "97px",
  width: "172px",
  backgroundColor: expanded ? "#FFF" : "#000",
  borderRadius: "4px",
  marginBottom: theme.spacing(0.5),
  border: expanded ? `1px dashed ${theme.palette.shades.neutral[100]}` : "none",
}));

export const VideoInnerContainer = styled(
  ({ expanded: _, ...props }: VideoContainerProps) => <Stack {...props} />
)(({ expanded }) => ({
  width: expanded ? "600px" : "100%",
  height: expanded ? "337px" : "100%",
  ...(expanded && {
    zIndex: 1000,
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "95%",
    maxHeight: "95%",
  }),
}));

export const VideoBackdrop = styled(Stack)({
  zIndex: 10,
  backgroundColor: "#0000008D",
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
});
